export const ACTIONS_TEXT = $localize`Actions`.toUpperCase();
export const NO_RESULTS = $localize`No Results Found!`;
export const YES_CHAR = $localize`Y`;
export const NO_CHAR = $localize`N`;
export const EXCEL_SHEET_NAME = $localize`Sheet1`;
export const CONFIRM_BUTTON = $localize`Yes`;
export const REJECT_BUTTON = $localize`No`;
export const EDIT_TEXT = `edit`;
export const ERROR_TEXT = `error`;

export const IMAGE_SRC = {
  ACTIVE: 'assets/check_circle.svg',
  ADD: 'assets/add.svg',
  ADD_CIRCLE: 'assets/add_circle.svg',
  ADD_CIRCLE_BLUE: 'assets/add_circle_blue.svg',
  ADD_PACKAGE: 'assets/addPackage.svg',
  ADD_WHITE: 'assets/add-white.svg',
  ALT_PHONE: 'assets/alt_phone.svg',
  ALT_CHECKBOX: 'assets/check_2.svg',
  ALT_FILTER: 'assets/alt-filter.svg',
  ARROW_LEFT_BLUE: 'assets/arrow_left_blue.svg',
  ARROW_RIGHT: 'assets/arrow-vector.svg',
  ARROW_DOWN: 'assets/arrows-down.svg',
  ASSIGN: 'assets/removeSharp.svg',
  ASC: 'assets/sort_asc.svg',
  BANNER_SUCCESS: 'assets/banner-success.svg',
  BANNER_FAIL: 'assets/banner-fail.svg',
  CANCEL: 'assets/cancel.svg',
  CANCEL_BLACK: 'assets/cancel-black.svg',
  CALENDAR: 'assets/date.svg',
  CAUTION: 'assets/caution.svg',
  CHECKBOX: 'assets/check_box.svg',
  CHECK_BLUE: 'assets/check_blue.svg',
  CHECK_BLACK: 'assets/check_black.svg',
  CHECK_WHITE: 'assets/check.svg',
  CHECK_OUTLINE: 'assets/check-outline.svg',
  CHECK_CIRCLE_BLUE: 'assets/check_circle_blue.svg',
  CHECK_CIRCLE_GREY: 'assets/check_circle_grey.svg',
  CHECK_CIRCLE_OUTLINE: 'assets/check_circle_outline.svg',
  CHECK_CIRCLE_OUTLINE_GREY: 'assets/check_circle_outline-gray.svg',
  CHECK_GREY: 'assets/check_grey.svg',
  CHEVRON: 'assets/ArrowDropdown.svg',
  CHEVRON_DOWN: 'assets/arrow-chevron-down.svg',
  CHEVRON_RIGHT_ALT: 'assets/arrow_right.svg',
  CHEVRON_RIGHT: 'assets/chevronRight.svg',
  CLEAR: 'assets/clearTextField.svg',
  CLEAR_WHITE: 'assets/clearTextField_White.svg',
  CLOSE: 'assets/close.png',
  CLOSE_SVG: 'assets/close.svg',
  CLOSE_BLACK: 'assets/close-black.svg',
  CLOCK: 'assets/clock_icon.svg',
  CLOCK_GRAY: 'assets/clock-gray.svg',
  DELIVERY: 'assets/delivery.svg',
  DELETE: 'assets/trash-red.svg',
  DELETE_INACTIVE: 'assets/trash.svg',
  DELETE_BLUE: 'assets/trash-blue.svg',
  DESC: 'assets/sort_desc.svg',
  ENABLED_CALENDAR: 'assets/calendar.svg',
  DELIVERY_BUTTON: 'assets/delivery-button.svg',
  DISABLED_CALENDAR: 'assets/disabled-calendar.svg',
  DONE: 'assets/sidebar-icons/done.svg',
  DOWNLOAD: 'assets/download.svg',
  EDIT: 'assets/edit.svg',
  EDIT_BLUE: 'assets/editBlue.svg',
  EDIT_WHITE: 'assets/edit-white.svg',
  EXCEL_ACTIVE: 'assets/excel-active.svg',
  EXCEL_INACTIVE: 'assets/excel-inactive.svg',
  EXCEL_WHITE: 'assets/excel-white.svg',
  FILTER_ACTIVE: 'assets/active-filter.svg',
  FILTER_INACTIVE: 'assets/inactive-filter.svg',
  GPD: 'assets/gpd-icon.svg',
  HAMBURGER: 'assets/Hamburger.svg',
  INFO: 'assets/info.svg',
  LINE: 'assets/line.svg',
  LOCATION: 'assets/mapViewPulltag.svg',
  LOCATION_DISABLED: 'assets/location.svg',
  LOCATION_WHITE: 'assets/location_white.svg',
  MESSAGING_NOTIF_ACTIVE: 'assets/notifications-message-active.svg',
  NON_URGENT: 'assets/non-urgent-issues.svg',
  NOTIFICATIONS: 'assets/notifications.svg',
  NOTIFICATION_ICON_ACTIVE: 'assets/notification-icon-active.svg',
  NOTIFICATION_ICON_EXPIRED: 'assets/notification-icon-expired.svg',
  NOTIFICATION_ICON_SUSPENDED: 'assets/notification-icon-suspended.svg',
  OPERATIONS_STOP: 'assets/shipping.svg',
  PHONE: 'assets/phone.svg',
  PICKUP: 'assets/pickup.svg',
  PICKUP_BUTTON: 'assets/pickup-button.svg',
  PRINTER: 'assets/printer!.svg',
  PRINTER_BLUE: 'assets/printer_blue.svg',
  QUESTION: 'assets/help-circle-outline.svg',
  REFRESH_OUTLINE_GREY: 'assets/RefreshBL_outline_grey.svg',
  REFRESH_OUTLINE: 'assets/RefreshBL_outline.svg',
  REMOVE_CIRCLE: 'assets/remove_circle.svg',
  SAVE: 'assets/save.svg',
  SAVE_ON: 'assets/SaveON.svg',
  SAVE_OFF: 'assets/SaveOFF.svg',
  SEARCH: 'assets/search.svg',
  SEND: 'assets/send.svg',
  SORT: 'assets/sort.svg',
  SORT_UP: 'assets/sort-arrow-up.svg',
  SORT_DOWN: 'assets/sort-arrow-down.svg',
  UNASSIGN: 'assets/addSharp.svg',
  UPS_ICON: 'assets/ups-shield.svg',
  URGENT_ISSUES: 'assets/urgent-issues.svg',
  USER_GUIDE: 'assets/user-guide.svg',
  USER_PIN: 'assets/user-pin.svg',
  WARNING: 'assets/warning-icon.svg',
  YIELD: 'assets/yield.svg',
  YIELD_BROWN: 'assets/yield-brown.svg',
};

export const STATUS_OPTIONS = {
  ALL_SELECTED: $localize`All`,
  SOME_SELECTED: $localize`Multiple`,
  ACTIVE: `Active`,
  SUSPENDED: `Suspended`,
  DEACTIVATED: `Deactivated`,
  INACTIVE: `Inactive`,
};

export const STOP_TYPE_OPTIONS = {
  ALL_SELECTED: $localize`All`,
  SOME_SELECTED: $localize`Multiple`,
  ON_DEMAND: $localize`OnDemand`,
  SCHEDULED: $localize`Scheduled`,
};

export const VALIDATION_MESSAGE = {
  CANADIAN_POSTAL_ERROR: $localize`! Invalid Postal Code`,
  REQUIRED: $localize`! Required`,
  MINIMUM: $localize`! Minimum %s length`,
  MAXIMUM: $localize`! Maximum %s length`,
  INVALID_EMAIL: $localize`! Enter valid email`,
  INVALID_LATITUDE: $localize`! Enter valid latitude`,
  INVALID_LONGITUDE: $localize`! Enter valid longitude`,
  DUPLICATED_VALUE: $localize`! %s already exists`,
  INVALID_VALUE: $localize`! Invalid %s`,
  DATE_ERROR: $localize`! From Date must not be later than To Date`,
  MIN_VALUE: $localize`! Min value: %s`,
  MAX_VALUE: $localize`! Max value: %s`,
  MAX_LENGTH_VALUE: $localize`! Max character length: %s`,
  DURATION: $localize`! Duration cannot exceed 120 min`,
  INVALID_BREAK: $localize`! Break End must be greater than Break Start`,
  SPECIAL_CHARACTERS_VALIDATION: $localize`! Only letters, numbers, dots, commas, and hyphens are allowed.`,
  MAX_LENGTH_CONSIGNEE_VALIDATION: $localize`! Consignee name must be 25 characters or fewer.`,
  MAX_LENGTH_STREET_VALIDATION: $localize`! Street Address must be 30 characters or fewer.`,
  MAX_LENGTH_VALUE_POSTAL_CODE: $localize`! Postal code must be 8 characters or fewer`,
};

const VALIDATION_UNSUCCESS = $localize`Validation unsuccessful.`;

export const VALIDATE_ADDRESS_RESPONSES = {
  VALIDATION_FAILED_SOURCE_INVALID:
    VALIDATION_UNSUCCESS + $localize`  Invalid source of request`,
  VALIDATION_FAILED_AAA_UNAVAILABLE:
    VALIDATION_UNSUCCESS + $localize`  AAA is unavailable`,
  VALIDATION_FAILED_INPUT_ADDRESS:
    VALIDATION_UNSUCCESS + $localize`  Input address not supplied`,
  VALIDATION_FAILED_REQUEST_ID:
    VALIDATION_UNSUCCESS + $localize`  Request ID is null/empty`,
  VALIDATION_FAILED_NULL_SITE_ID:
    VALIDATION_UNSUCCESS + $localize`  Site ID is null/empty`,
  VALIDATION_FAILED_NO_LATLONG: VALIDATION_UNSUCCESS,
  VALIDATION_SUCCEEDED: $localize`Validation successful. Please Submit.`,
};

export const ALERT_MODAL = {
  HEADER: $localize`Alert!`,
  BODY: $localize`Selected Route ID can't be deleted. All pickups must be unassigned from Route prior to removal.`,
  CONFIRM_BUTTON: $localize`Ok`,
  REJECT_BUTTON: '',
};

export const DELETE_MODAL = {
  HEADER: $localize`Remove Route`,
  BODY: $localize`Are you sure you want to remove the following route? %s`,
  CONFIRM_BUTTON: CONFIRM_BUTTON,
  REJECT_BUTTON: REJECT_BUTTON,
};

export const TIME_RANGES = [
  {
    label: '00:00',
    value: '00:00',
  },
  {
    label: '01:00',
    value: '01:00',
  },
  {
    label: '02:00',
    value: '02:00',
  },
  {
    label: '03:00',
    value: '03:00',
  },
  {
    label: '04:00',
    value: '04:00',
  },
  {
    label: '05:00',
    value: '05:00',
  },
  {
    label: '06:00',
    value: '06:00',
  },
  {
    label: '07:00',
    value: '07:00',
  },
  {
    label: '08:00',
    value: '08:00',
  },
  {
    label: '09:00',
    value: '09:00',
  },
  {
    label: '10:00',
    value: '10:00',
  },
  {
    label: '11:00',
    value: '11:00',
  },
  {
    label: '12:00',
    value: '12:00',
  },
  {
    label: '13:00',
    value: '13:00',
  },
  {
    label: '14:00',
    value: '14:00',
  },
  {
    label: '15:00',
    value: '15:00',
  },
  {
    label: '16:00',
    value: '16:00',
  },
  {
    label: '17:00',
    value: '17:00',
  },
  {
    label: '18:00',
    value: '18:00',
  },
  {
    label: '19:00',
    value: '19:00',
  },
  {
    label: '20:00',
    value: '20:00',
  },
  {
    label: '21:00',
    value: '21:00',
  },
  {
    label: '22:00',
    value: '22:00',
  },
  {
    label: '23:00',
    value: '23:00',
  },
];

export const ITEMS_PAGE_LABEL = $localize`Show: `;

//This is used to make state/province field optional.
// All these fields are in R16 group and have to be spelled out here since not all users can access
// get linked sites to get the up-to-date list.  This is current (check in prod) as of 5/1/25
export const EUROPEAN_LOCATION_CODES: string[] = [
  'GBGLU',
  'KGBIS',
  'RUOMK',
  'OLYMPIC',
  'DEWEN',
  'PLSZ1',
  'RURYA',
  'ITORI',
  'GBLED',
  'BGOFI',
  'BAEVO',
  'ITTOR',
  'GBDAV',
  'MWLIL',
  'UAODE',
  'FRAFA',
  'RSPRI',
  'NLTIB',
  'RUKOM',
  'ESMAN',
  'SMRAV',
  'BHMUH',
  'IECOK',
  'TRES1',
  'FRLYO',
  'ITTORSEC',
  'DEKOL',
  'TRKA1',
  'FRLST',
  'SEMOLIN',
  'SEVSTPN',
  'GBLND',
  'GBGSG',
  'EGCAI',
  'GBGLO',
  'TNRAD',
  'ITOMA',
  'ATKAL',
  'ATHOE',
  'BS2BE',
  'RUYAK',
  'GBOWL',
  'PLBLI1',
  'PTLOU',
  'FR130',
  'DEWSL',
  'FRSTH',
  'PLLEC1',
  'FRPLI',
  'FRLLE',
  'TRAN7',
  'TRYES',
  'TRKO1',
  'TRKO2',
  'CDKNA',
  'PLPAN',
  'GBSHM1',
  'FRALV',
  'TRIMR',
  'FRNOA',
  'SABAR',
  'AFBAG',
  'AFKAN',
  'PLNSZ',
  'FRTORCTR',
  'DEHME',
  'RUNOO',
  'RUYAR',
  'RUCHI',
  'RUIZH',
  'PTHUB',
  'FRCAE',
  'FRSAT',
  'GBNTW',
  'IEDUB',
  'ITFRO',
  'SEARLIN',
  'DENSS',
  'TRI14',
  'DEKAS',
  'DKAAL',
  'HUGRO',
  'RUTUL',
  'DENURSUB',
  'BELUM',
  'FRCSV',
  'MRNOU',
  'TRAF1',
  'TRIZ4',
  'IETRA',
  'RUPEN',
  'PLKLS1',
  'RWKIG',
  'RUKHA',
  'DEOTZ',
  'CHARL',
  'CHMEY',
  'RUSIM',
  'IECRK',
  'NLAMS',
  'LTBRU',
  'FRLIL',
  'DEWOL',
  'RUKEM',
  'ITRAG',
  'TRKO6',
  'TRKO7',
  'TRAT6',
  'DEWLL',
  'TRAN8',
  'BFOUA',
  'DEBAT',
  'ERAMA',
  'FRBBJ',
  'SEMOL',
  'NOOLO1',
  'CYSTR',
  'MUPOU',
  'ESGUR',
  'SEMST',
  'AEDUI',
  'ESTEN',
  'KMMOR',
  'ITCTLSEC',
  'TRAYM',
  'GBBRG',
  'ILBSH',
  'INAHM',
  'INYEL',
  'INCMB',
  'INDEI',
  'INHYB',
  'INBEG',
  'INJPR',
  'INBRA',
  'INDOR',
  'INKPR',
  'INMEE',
  'IN128',
  'INVII',
  'DEBIN',
  'DELAN',
  'CZPRG',
  'IESWD',
  'RFSDE',
  'TMASH',
  'ESBRJ',
  'SEMJO',
  'CZPNS',
  'FRFEY',
  'ITLAE',
  'KVPRI',
  'MZMPU',
  'RNFDE',
  'GBBUR',
  'GBNTG',
  'FRSNT',
  'FRBOU',
  'TRGA1',
  'TRI20',
  'ITMILSEC',
  'RUDVI',
  'TRI30',
  'TRKO3',
  'BJCOT',
  'TRKR1',
  'GBSED',
  'GBGTE',
  'FRLCU',
  'FRPTV',
  'TRTOK',
  'FRCDG',
  'NGBAU',
  'NGKAD',
  'NGMAI',
  'ITSET',
  'ATHAL',
  'NGABU',
  'RUARK',
  'MTLQA',
  'RUUSS',
  'DEKIRCTR',
  'CHGRN',
  'TRI17',
  'FRJON',
  'TRBIT',
  'UZTSK',
  'ITBEL',
  'ESMANCTR',
  'TRNAA',
  'TJDUS',
  'GHACC',
  'FRNICOSP',
  'DENAU',
  'GRTHI',
  'AFKAU',
  'FRSAH',
  'SAJED',
  'DEULM',
  'AEABI',
  'DEBLS',
  'NGMAK',
  'DJJIB',
  'NGIBA',
  'TRIMI',
  'ITBRGSEC',
  'ITBRSSEC',
  'RUSOC',
  'IEKLL',
  'IEFIN1',
  'SEKAS',
  'NGCAL',
  'ITSIN',
  'RUEKA',
  'TRAD1',
  'TRATM',
  'TR110',
  'FRBOR1',
  'ITTES',
  'RUKAU',
  'RULED',
  'ITBLQ',
  'DEBON',
  'RUVOL',
  'TRAT3',
  'TRI26',
  'TRI31',
  'DEKAR',
  'TDNDJ',
  'GNCON',
  'NLOOS',
  'DEISECTR',
  'ESGURCTR',
  'CZONL',
  'TRAM1',
  'TRI11',
  'RUMSO',
  'ITCBZ',
  'DEBRE',
  'DEBLN',
  'DZAGR',
  'PLBBL1',
  'GBROD',
  'QAOHA',
  'ESALI',
  'ITBLG',
  'FRSJQ',
  'DESAL',
  'FRSTQ',
  'CYAGI',
  'PTMAI',
  'PLMOD',
  'FRECQ',
  'IN254',
  'INMMI',
  'INNLI',
  'INAHE',
  'INPNP',
  'INPAN',
  'INJGR',
  'INJOH',
  'INALI',
  'INAMB',
  'INSRT',
  'INAMA',
  'ININR',
  'INTLM',
  'FRDSC',
  'ROOPN',
  'NGLAS',
  '99ROGHI',
  'ROCIA',
  'RUAFU',
  'AZBAK',
  'DEFEC',
  'IEOUT',
  'SEMOLAI',
  'ITTEN',
  'SEVAX',
  'RUSMO',
  'GBEXR',
  'ITGEO',
  'FRSPL',
  'UALVO',
  'NOSTO',
  'MZMPO',
  'IELMR',
  'IEWAR',
  'GBBAS',
  'RUNNO',
  'PL66A',
  'BEGHO',
  'TRAN6',
  'TRDI2',
  'ITBER',
  'TRI28',
  'TRIB4',
  'TRIS6',
  'TRIZ0',
  'TRKL1',
  'SESUN',
  'NOSTA',
  'TRTB1',
  'TRSM1',
  'TRSM2',
  'FRBRY',
  'GBNHA',
  'ZADUA',
  'TNTUN',
  'TRIST',
  'GBEMR',
  'ITARE',
  'LYBEG',
  'LTVIL',
  'ITSECSCAN',
  'NGSOK',
  'IESHN',
  'GBTAP',
  'DEBRA',
  'ITTMU',
  'RUTUA',
  'ESBCA',
  'FRGRE',
  'DKKOL',
  'TRGA2',
  'ITMPA',
  'TRI18',
  'TRIZ8',
  'ATLAT',
  'GBLMC',
  'TRKI1',
  'TRSM3',
  'DEWIT',
  'RUMAK',
  'DEKEM',
  'OMCAT',
  'PLPIA1',
  'ATWEN',
  'ITPOL',
  'ITBRG',
  'DEULMSUB',
  'NGAKU',
  'DEOBT',
  'DEBLD',
  'RUMAN',
  'PKLAE',
  'GBBWA',
  'DEBAM',
  'RUPTZ',
  'FRMAU',
  'GBWAT',
  'TRI22',
  'DEKIE',
  'GBDEW',
  'ZAJNN1',
  'AMYEV',
  'DEWES',
  'JEHEL',
  'GBPWD',
  'GIGBT',
  'DEGRBSUB',
  'TRAAM',
  'ITFOR',
  'TRAT5',
  'RUULN',
  'RUVRA',
  'FRCRB2',
  'DEGRO',
  'ITCAA',
  'GBCAF',
  'NLEDN',
  'SEJNK',
  'ESBRS',
  'FRSTG',
  'FRLYB',
  'PTLRA',
  'ITMIL',
  'FIHLSA',
  'DENOT',
  'SESTO3',
  'ILLOD',
  'ITLURSEC',
  'ESSRD',
  'INCHI',
  'INDEL',
  'INKER',
  'INPUE',
  'INNAS',
  'TRIS8',
  'DEESH',
  'DEHED',
  'PLSTR1',
  'ITSIE',
  'RFTDE',
  'RUMOS01',
  'RUBRY',
  'RUVEL',
  'FRTUE',
  'NAWIN',
  'FRERX',
  'AFCLN',
  'ITVIM',
  'GBCLS',
  'RUSAM',
  'MLBMA',
  'GBSHF',
  'TRER1',
  'TRI29',
  'TRI34',
  'ITVERSEC',
  'TRIS2',
  'TRKA2',
  'SESKE',
  'TRLIM',
  'TRME1',
  'TRAD4',
  'FRCAN',
  'ITPRT',
  'GBSHM',
  'ESMARF',
  'FRNIC',
  'NGENU',
  'PLSIT1',
  'CGBRZ',
  'ITOBA',
  'RUVLD',
  'CHRUE',
  'GBAGN',
  'DKCOP',
  'FRLEM',
  'GBGAW',
  'ESAST',
  'PLSTR',
  'ESMAI',
  'GBBUK',
  'TRER3',
  'PKSLK',
  'DESAA',
  'RUPYA',
  'ITVER',
  'TRI13',
  'RUTAM',
  'NGMMI',
  'RUNAB',
  'RUNOR',
  'CYLIM',
  'KWFWY',
  'NENIA',
  'DEFRI',
  'DKAAU',
  'GBSTO',
  'RUNOV',
  'ITSAV',
  'ITAOISEC',
  'ITBLGSEC',
  'DEWAL',
  'FRFON',
  'FRPLA',
  'RUKIR',
  'FRREA',
  'FRTRO',
  'DEKAI',
  'RUNIZ',
  'DEFECSUB',
  'IESLI',
  'CDKLW',
  'ATVIA1',
  'RUNAK',
  'BYMSK',
  'FRCHI',
  'PLGDA',
  'ITSMA',
  'RUORB',
  'DEGERSUB',
  'ETADD',
  'LRMON',
  'NOOLOMVP',
  'GBSLHCTR',
  'GGSTS',
  'DEKRI',
  'DEROS',
  'DEGIE',
  'NLRTT',
  'ITTST',
  'DEECH',
  'RUPSK',
  'SCADG',
  'DEGRB',
  'MADILOOSP',
  'ITVCNSEC',
  'ITVCN',
  'ESBIL',
  'KEOBI',
  'CYNCO',
  'ITPIASEC',
  'ITPRTSEC',
  'IN789',
  'INKOL',
  'INLUI',
  'INCNI',
  'INMAI',
  'INCHA',
  'INKNR',
  'INTRU',
  'INBRD',
  'INCOI',
  'INGGN',
  'NPKAT01',
  'LKCOO',
  'NPKAT02',
  'ROGRD',
  'PLOZN1',
  'CVPRA',
  'ITBOO',
  'RUKAZ',
  'RUCHY',
  'IEFNG',
  'RMGDE',
  'RULIP',
  'FRVIL',
  'CGPTR',
  'NLAPO',
  'IERSC',
  'SEJNKPN',
  'RSBEL',
  'FRTLS',
  'ESVID',
  'RERDE',
  'MAAGA',
  'MAFES',
  'FITUK',
  'DEUEL',
  'DEREN',
  'MGANT',
  'KZLUG',
  'IEDBN1',
  'TRAT2',
  'TRGA5',
  'FRSLT',
  'ITCRPSEC',
  'TRIS9',
  'DEDAH',
  'TRIZ2',
  'TRKA3',
  'MEPOD',
  'GBATL1',
  'GBBOD',
  'GBDAR',
  'BELUM1',
  'GBDDE',
  'TRSM4',
  'RPFDE',
  'MDCHS',
  'RUABR',
  'GBSTH',
  'DESCK',
  'FRMSL',
  'ITCAR',
  'ITROM',
  'NOTRO',
  'ITLIS',
  'RUBRT',
  'DEISE',
  'PLMIR1',
  'NGABE',
  'NGJOS',
  'NGWAR',
  'RSSIM',
  'RUVAN',
  'CDLUB',
  'AOLUN',
  'ESIBI',
  'TRI21',
  'ITCAL',
  'ITPLE',
  'GBWAR',
  'TRAN5',
  'TRBU2',
  'RUTYU',
  'TRHAT',
  'FRLAC',
  'ITORT',
  'CYNIO',
  'K49000002',
  'CYLRN',
  'FRREM',
  'FOSOR',
  'NGLOK',
  'NGOWE',
  'ITCRP',
  'DESCH',
  'ITFGG',
  'SIZGO',
  'FRLIM',
  'GRARG',
  'ESBAD',
  'FRMUL',
  'PLGDA1',
  'SEMSTPN',
  'RUTOS',
  'TMAHG',
  'RUSTA',
  'IEVIR',
  'NOOLO2',
  'RUAZO',
  'TRI15',
  'ATSPS',
  'GBMNS',
  'PLAKO1',
  'RUCHE',
  'RUCHP',
  'GRKOP',
  'BR2BE',
  'PLKOZ1',
  'DECRA',
  'RUKRS',
  'ATINB',
  'IEFIN',
  'TRI19',
  'TRI36',
  'TRITA',
  'GBTPC',
  'DEHER',
  'GBEDS',
  'DEKIR',
  'ITMOD',
  'TRAN2',
  'TRIZ7',
  'RUMOS',
  'RUULA',
  'RUNOK',
  'UAKIV',
  'ITMIO',
  'TZDSA',
  'FRGSA',
  'FRTLO',
  'ESORE',
  'ITFTO',
  'FRMAR',
  'ITPLESEC',
  'BEBSE',
  'YTDZA',
  'DEGER',
  'CYARA',
  'FRVTL',
  'DEDUS',
  'INTIR',
  'INBAD',
  'INJAA',
  'INJOP',
  'INVPI',
  'INOKH',
  'INWDL',
  'IN357',
  'ITCPI',
  'AIRALLIANC',
  'PTPVO',
  'ITCTL',
  'ESBAL',
  'RUPER',
  'DEDIT',
  'SESTOAI',
  'SKBLV',
  'ITPDA',
  'OMMSC',
  'RUORE',
  'SEARLPN',
  'FRROU',
  'MAMAK',
  'ITBOZ',
  'ITLVR',
  'DELOB',
  'DEHMN',
  'AEDUI1',
  'IEATH',
  'SNDKA',
  'FIHOU',
  'TRIB3',
  'ITROMSEC',
  'ITTNOSEC',
  'TRIZ6',
  'TRKC1',
  'GBBAR',
  'SESTOIN',
  'SESTOPN',
  'DENUR',
  'FRNAB',
  'ITLAQ',
  'ITSBO',
  'NOGAR',
  'ITFRM',
  'TRISTE',
  'LYTRP',
  'GBCUM',
  'CIABI',
  'NGGOM',
  'ATGRO',
  'ATWAL',
  'RUVOR',
  'FRENR',
  'GQMAL',
  'PLBLI',
  'ITCLT',
  'PLUMI1',
  'PLBYG',
  'ITAOI',
  'TRAT4',
  'TRI16',
  'SLFRE',
  'ITLUR',
  'ITUDE',
  'GBREA',
  'NLBST',
  'FRORL',
  'SESTO6',
  'NGKAT',
  'DEFRE',
  'ITTORCTR',
  'FRCTL',
  'GBDEE',
  'NGPHC',
  'RUMUR',
  'ITGSG',
  'RUBEL',
  'ITCGL',
  'NLUTR',
  'MKPJE',
  'RUKUS',
  'FITMPPI',
  'ITSSS',
  'RUYKR',
  'ATWOL',
  'FRMON',
  'ATWIN',
  'FRTUE1',
  'AEJLL',
  'NGILO',
  'FRSTR',
  'FRSON',
  'GBUML',
  'GBSWA',
  'TRBU1',
  'FRSLL',
  'LULUM',
  'FRTOR',
  'ESBEN',
  'GBSLH',
  'RUMAG',
  'GETBS',
  'ATALL',
  'TRI37',
  'TRAN3',
  'IQBAG',
  'KWKWI',
  'GRATE',
  'BWGBR',
  'DEUMK',
  'TRIGA',
  'TRIS5',
  'TRTR1',
  'LVRIX',
  'AEDXB',
  'PLRZK1',
  'NLHEE',
  'BIBJB',
  'LBBEI',
  'ITNVR',
  'HRHLE',
  'CHWLB',
  'RUBUT',
  'ITMII',
  'RUKOS',
  'FIHLS',
  'ITNUO',
  'GBTAS',
  'FRMEJ',
  'EETNN',
  'ZACTO',
  'QADOA',
  'SEVST',
  'INDAB',
  'INKRU',
  'INLDH',
  'INMRD',
  'INPON',
  'INKAR',
  'INYDR',
  'INAMR',
  'LKCOL',
  'DEICT',
  'GBNRW',
  'RUKLN',
  'RUKRJ',
  'UGENT',
  'ROKDE',
  'NOBLO',
  'ITSRI',
  'GBNTM',
  'GBTEL',
  'FRBRE',
  'FRCLE',
  'MWBLA',
  'MARBT',
  'DEMDG',
  'RUBDE',
  'GBSHE',
  'ITLURMVP',
  'RUAST',
  'JOAMM',
  'DEDSS',
  'TZARS',
  'FIROV',
  'ITSSSSEC',
  'BEBRA',
  'TRIS7',
  'GRKOP02',
  'TRKO4',
  'TRKO5',
  'DEGIM',
  'NLHFP',
  'GBEXE',
  'ITARZ',
  'ITBRS',
  'ITROA',
  'PKKRH',
  'NGBEN',
  'NGKAN',
  'ESZAR',
  'TGLOM',
  'SEARL',
  'RUSAR',
  'KIAFR',
  'TRAF2',
  'CFBAN',
  'GBLIN',
  'GBMCH',
  'ITCVM',
  'PLSKR',
  'TRI35',
  'TRSA2',
  'GBROY',
  'FRNCY',
  'DEMRG',
  'FRCHN',
  'DEALL',
  'ITMODCPI',
  'DEFRESUB',
  'PLWAW',
  'FRLET',
  'DELAH',
  'SZMTS',
  'RUKHM',
  'DEWENSUB',
  'RUSUR',
  'ITCGLSEC',
  'ITNVRSEC',
  'ITFII',
  'RUMOW',
  'GBOMA',
  'LYVEOSP',
  'FIHLSPI',
  'HUVSS',
  'FRBGS',
  'TRGA3',
  'TRGA4',
  'ATVIL',
  'CONSORZIO',
  'ITMNT',
  'FRBRD',
  'DEDITSUB',
  'PLMYS1',
  'RUKUR',
  'TRAN9',
  'SARIA1',
  'RUORS',
  'ISKEL',
  'TRAD2',
  'TRI25',
  'ITPOR',
  'ITRAE',
  'DEUMKSUB',
  'FRSAB',
  'ZWHRR',
  'ALTIR',
  'DEKLI',
  'RUSYK',
  'ADAND',
  'ZAPTE',
  'RUTVE',
  'PLBLY1',
  'TRAD3',
  'TRVA1',
  'RUNVU',
  'UALUG',
  'TRAT1',
  'ATWUN',
  'RUBAR',
  'ITROASEC',
  'ILCAR',
  'ITTNO',
  'FRCRB',
  'ESMHN',
  'ITVZA',
  'FRBOR',
  'ESMAL',
  'SADHA',
  'CZOSV',
  'SARIA',
  'GALBR',
  'GBGFR',
  'GBLEY',
  'FRAUL',
  'PLRDO1',
  'INGAO',
  'IN3AN',
  'INAGA',
  'INVRN',
  'INBLU',
  'INNAI',
  'INUDA',
  'LOGINEXTIN',
  'MVMAL',
  'NPKAT',
  'TRIS4',
  'DEBEN',
  'FIJYS',
  'ESLAC',
  'ESLUG',
  'ITPEC',
  'FRNSG',
  'IQERB',
  'RUNAC',
  'RUPET',
  'SYDAM',
  'YESAN',
  'FRBRG',
  'FRNTS',
  'LSMSE',
  'RGHDE',
  'SEKAL',
  'MATAN',
  'SADHH',
  'ESMOZ',
  'DEESF',
  'GBNTA',
  'ZMLSK',
  'GBCRO',
  'ESMEN',
  'RUYUZ',
  'FRLDC',
  'GMKAN',
  'AOLAN',
  'TRBI1',
  'SELIN',
  'RUIRK',
  'TRI10',
  'ITBOOSEC',
  'TRI33',
  'TRIS1',
  'TRIZ3',
  'TRMA1',
  'DECGN',
  'GBBTO',
  'TRME2',
  'NGMIN',
  'GBEDR',
  'GBLTN',
  'FRFZN',
  'GBCHL',
  'ITCAS',
  'ITPAR',
  'FRTMU',
  'IEGAL',
  'ITPIA',
  'ATEBT',
  'ESMAR',
  'GBIVE',
  'RUVDM',
  'GBTAM',
  'TRI38',
  'AELW1',
  'GBBTL',
  'TRAN1',
  'KIPPDE',
  'CMCDU',
  'TRIZ1',
  'TRIS3',
  'TRKU1',
  'TRSA1',
  'DEBENSUB',
  'FRAULMVP',
  'TNENA',
  'DEKARSUB',
  'FRPOI',
  'ATWIE',
  'NLEVN',
  'NGONI',
  'DEREI',
  'FRANG',
  'NGABA',
  'NGZAR',
  'NGUYO',
  'ITLEC',
  'ITIMP',
  'RUVYB',
  'FRSTJ',
  'NGYOL',
  'GBMNS1',
  'PLCZT1',
  'FRPAM',
  'ITARZSEC',
  'SEMOLPN',
  'RUIVA',
  'RUSAV',
  'RUBLA',
  'RUVKO',
  'RURST',
  'NLWAA',
  'ITGRO',
  'GLNUK',
  'TRAN4',
  'ITPRG',
  'MAANC',
  'PLGRW1',
  'RUARY',
  'PLWKO',
  'DEGAR',
  'GWBIS',
  'TRI23',
  'TRI24',
  'TRIZ5',
  'PLWAR',
  'DEOBL',
  'RUSPE',
  'FRPON',
  'ZAJNN',
  'MTLQAMVP',
  'CZBNO',
  'TRTE1',
  'ITTTO',
  'ITTRO',
  'TRDI1',
  'TRSR1',
  'DEPAD',
  'GBATL',
  'HRVEL',
  'ESSEV',
  'ITCAN',
  'TZDES',
  'DEFRISUB',
  'DEWUP',
  'RESTM',
  'NOOLO',
  'MGANV',
  'ESVIG',
  'FRBRU',
  'FITMP',
  'ESGCA',
  'FROUA',
  'ITVZASEC',
  'PLMAT1',
  'ILHAI',
  'INMUA',
  'INBAI',
  'INBGR',
  'INCOH',
  'INARA',
  'INKAN',
  'INNDH',
  'INMAD',
  'IN180',
  'ILTLV',
  'BDDHA',
  'PLOPO',
];
